export default __webpack_public_path__ + "static/media/logo.b87eaae4.png";